import React from "react";
import Button from "@material-ui/core/Button";
import { Dialog as GenericDialog, GenericDialogProps } from "./dialog";
import { Formik, useFormikContext } from "formik";
import { Label } from "./formInputs";
import { ErrorCommon, SelectField, TextFieldCommon,TextField } from "./formikFormInputs";
import { Grid, Typography } from "@material-ui/core";
import { paymentRejectedDropdown } from "../pages/client/Enrollment/EnrollmentHome/basicInfo/PersonalDetailUtils";



export default function RejectPayment(props: any) {
    const initialValues = {};
    const validate = ((value: any) => {
        let errors: any = {};
        if (!value.paymentRejectedReason) {
            errors.paymentRejectedReason = 'Required';
        }
        return errors;
    });
    const dialogProps: GenericDialogProps = {
        "aria-labelledby": "terms-and-conditions-dialog-title",
        fullWidth: true,
        maxWidth: "sm",
        content: (
                <>
                    <Typography variant="body1" className="mb15 floatLeft w100"> This ePay payment was rejected due
                        to</Typography>
                    <Formik
                            initialValues={initialValues}
                            enableReinitialize={true}
                            validate={values => validate(values)}
                            validateOnChange={true}
                            onSubmit={async (...porps) => {
                                if(props.onSubmit){
                                    props.onSubmit(...porps)
                                }
                            }}
                    >
                        {(formikProps) => (

                                <RejectPaymentFormContent {...formikProps} />

                        )}
                    </Formik>
                </>
        ),
        dividers: true,
        onClose: () => props.setRp(false),
        open: props.showRp,
        title: "Reject Payment",
    };
    return (
            <GenericDialog {...dialogProps} />
    );
}

function RejectPaymentFormContent(props: any) {
    const {errors,touched, values, handleChange, handleBlur} = useFormikContext<any>();
    const fieldObj:any = [
        {
            name: "paymentRejectedReason",
            label: <Label label={"Payment was rejected"} required={true} />,
            isRequired: true,
            component: SelectField,
            className: "SelectFieldWidth",
            variant: "outlined",
            options: paymentRejectedDropdown,
        },

    ];
    if(values["paymentRejectedReason"] == "other"){
        fieldObj.push({
            id: "message",
            key: "message",
            name: "message",
            label: <Label label={"Why the payment was rejected"} required={true} />,
            isRequired: true,
            component: TextField,
            variant: "outlined",
            multiline: true,
            rows: 5,
        })
    }
    return (
            <form onSubmit={props.handleSubmit}>
                <Grid container spacing={2}>
                    {fieldObj.map((field, index) => {
                        return (
                                <Grid item xs={12} key={index}>
                                    <TextFieldCommon
                                             {...field}
                                             values={values}
                                             onChange={handleChange}
                                             onBlur={handleBlur}
                                    />
                                    <ErrorCommon errors={errors}
                                                 name={field.name}
                                                 touched={touched} />
                                </Grid>
                        );
                    })
                    }
                    <Grid item xs={12}>
                        <Button
                                size="small"
                                variant="contained"
                                color="primary"
                                className="floatRight"
                                type="submit"

                        >
                            Reject Payment
                        </Button>
                    </Grid>
                </Grid>
            </form>
    );
}